import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import { AppMessages } from '../../strings';

const ConfirmAcknowledgmentModal = ({shouldShow, onConfirmAcknowledgment, onClose}) => {

  	return (
		<>
			<Modal  show={shouldShow} centered onHide={onClose} style={{color:'white'}}>
				<Modal.Header closeButton >
					<Modal.Title>Acknowledge</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>{AppMessages.confirmAcknowledgment}</p>
				</Modal.Body>
				
				<Modal.Footer>
				<Button onClick={() => onClose()} variant='secondary' style={{color:'black', background:'#8A8B87'}}>
					Cancel
				</Button>
				<Button onClick={() => onConfirmAcknowledgment()} style={{color:'black', marginRight:10}}>
					Confirm
				</Button>
				</Modal.Footer>
			</Modal>
		</>
		
  	);
}

export default ConfirmAcknowledgmentModal;